<template>
    <layout-theme>
        <layout-header />

        <div id="background"
            @mouseenter="screensaverCheck" 
            @mousemove="screensaverCheck" 
            @mouseleave="screensaverCheck"
            :class="[screensaverShow ? 'higthzindex' : 'nozindex']"
        >
            <img v-if="screensaverShow && background" :src="background" class="stretch" />
        </div>

        <div class="container mt-5">
            <div class="columns mt-5 is-centered">
                <div class="column is-10 mt-3">
                    <b-notification 
                        v-if="signInMessage"
                        type="is-warning is-light" 
                        @close="$store.commit('clearSignInMessage')"
                    >
                        {{ signInMessage }}
                    </b-notification>
                    
                    <b-field
                        :type="{ 'is-danger': !!errors.user_id }"
                        :message="errors.user_id"
                    >
                        <b-input
                            id="input-username"
                            v-model="username"
                            :placeholder="$ml.get('Usuário')"
                            autocomplete="off"
                        />
                    </b-field>

                    <b-field>
                        <b-input
                            id="input-password"
                            v-model="password"
                            type="password"
                            :placeholder="$ml.get('Senha')"
                            @keyup.native.enter="login"
                        />
                    </b-field>

                    <div class="columns mt-5">
                        <div class="column is-12 mt-3" >
                            <b-button 
                                @click="login" 
                                type="is-primary" 
                                size="is-large" 
                                expanded
                            >
                                {{ $ml.get('Entrar') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </layout-theme>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import api from '@/api.js'
import LayoutTheme from '@/components/LayoutTheme.vue'
import LayoutHeader from '@/components/LayoutHeader.vue'

const NEXT = '/update'

export default {
    name: 'Login',

    components: {
        LayoutTheme,
        LayoutHeader,
    },


    beforeRouteEnter (to, from, next) {
        next(vm => {
            if (!vm.equipment) {
                vm.$router.push({ name: 'Setup' })
            }
        })
    },

    data() {
        return {
            username: '',
            password: '',
            errors: {},
            background: null,
            screensaverShow: false,
            screensaverIdleAfter: 60,
            screensaverTimeout: null,
        }
    },

    mounted() {
        if (this.unit && this.unit.id) {
            const options = {
                url: 'background/search',
                method: 'get',
                params: {
                    q: JSON.stringify({
                        filters: [{
                            conditions: [{
                                field: 'login',
                                value: '1',
                            }]
                        },{
                            operator: 'has',
                            relationship: 'units',
                            conditions: [{
                                type: "in-list",
                                field: 'id',
                                value: [this.unit.id]
                            }]
                        }]
                    }),
                },
                loading: false
            }
            
            api.appRequest(options).then(({ data }) => {
                if (data && data.length) {
                    this.background = _.sample(data).image
                    this.screensaverCheck()
                }
            })
        }
    },

    methods: {
        screensaverCheck() {
            if (this.screensaverTimeout) {
                clearTimeout(this.screensaverTimeout)
                this.screensaverShow = false
            }

            this.screensaverTimeout = setTimeout(() => {
                this.screensaverShow = true
            }, this.screensaverIdleAfter*1000);
        },

        authenticate(username, password) {
            return api.authenticateUser(username, password)
        },

        startUsage(equipmentId) {
            return api.userRequest({
                url: `booking/equipment/${equipmentId}/start`,
                method: 'post',
            })
        },

        showErrors(e) {
            let message = e.message

            if (e.response && e.response.data) {
                const data = e.response.data
                if (data.message) {
                    message = data.message
                } else if (data.error) {
                    switch (data.error) {
                        case 'invalid_credentials':
                            message = 'As credenciais estão incorretas.'
                            break;
                    
                        default:
                            message = data.error_description ? data.error_description : data.error
                            break;
                    }
                } else if (data.exception && data.exception.type) {
                    switch (data.exception.type) {
                        case 'UserNotFrequenterException':
                            message = 'Esse usuário não é um frequentador.'
                            break;
                    
                        case 'ValidationException':
                            if (data.exception.details) {
                                message = Object.values(data.exception.details)[0][0]
                            } else {
                                message = data.exception.message ? data.exception.message : data.exception.type
                            }
                            break

                        default:
                            message = data.exception.message ? data.exception.message : data.exception.type
                            break;
                    }
                }
            }

            this.$buefy.dialog.alert({
                message,
                type: 'is-danger',
            })

            this.password = ''
        },

        login() {
            if (!this.username) {
                this.$buefy.dialog.alert({
                    message: this.$ml.get('Digite o seu nome de usuário'),
                    type: 'is-danger',
                })
                return
            }

            if (!this.password) {
                this.$buefy.dialog.alert({
                    message: this.$ml.get('Digite a senha'),
                    type: 'is-danger',
                })
                return
            }

            const loading = this.$buefy.loading.open()

            this.authenticate(this.username, this.password).then(user => {
                console.log('Usuário autenticado com sucesso!')
                this.startUsage(this.equipment.id).then(({ booking }) => {
                    console.log('Utilização iniciada com sucesso!')
                    this.$store.dispatch('renewAuthorizationApp')
                    this.$store.commit('setUser', user)
                    this.$store.commit('startTimeoutSession', this.$router)
                    this.$store.commit('setUsage', booking)
                    this.$router.push(NEXT)
                }).catch(this.showErrors)
            }).catch(this.showErrors).finally(() => loading.close())
        },
    },

    computed: {
        ...mapGetters({
            equipment: 'getEquipment',
            unit: 'getUnit',
            signInMessage: 'getSignInMessage',
        })
    },
}
</script>

<style scoped>
#background {
    width: 100%; 
    height: 100%; 
    position: absolute; 
    left: 0px; 
    top: 0px; 
}

.nozindex {
    z-index: 0 !important;
}
.higthzindex {
    z-index: 9999 !important;
}

.stretch {
    width:100%;
    height:100%;
    z-index: 99999;
}
</style>